import * as React from 'react';

import Box from '@mui/material/Box';
import GaugeComponent from 'react-gauge-component'




export default function RadialChart(props :any) {
  return (
    <Box sx={{
      '& svg' : {width:140, height:120,mt:'-10px' }
    }}>
    <GaugeComponent
   // style={weightChart}
  value={props.value}
  type="radial"
  labels={{
    tickLabels: {
      type: 'inner',
      defaultTickValueConfig: { 
     
    },
      ticks: [
        { value: 30 },
        { value: 60 },
        { value: 90 },
        { value: 120 },
        { value: 150 }
      ],
    },
    valueLabel: {
      hide:true,
      // style: { fontSize: "50px", fontWeight:700, fill: "#555", textShadow: "0" }
    },
  }}
  minValue={0}
  maxValue={150}
      
  arc={{
    colorArray: ['#b3c3cf'],
    subArcs: [{limit: 30}, {limit: 60}, {limit: 90}, {limit: 120}, {limit: 150}],
    padding: 0.03,
    width: 0.2
  }}
  pointer={{
    elastic: true,
    animationDelay: 0,
    color: '#bd0000',
    length: 0.80,
  }}

/>
</Box>
   

  );
}

const weightChart = {
      width:140, 
      height:120,
      marginTop:'-10px'
}